import Const from 'const';
import {FilterLineupsByTeamCombinationsInterface} from 'components/molecules/filter-lineups-by-team-combinations/filter-lineups-by-team-combinations-interface';
import {ComboUnitInterface} from 'components/organisms/teams-combinations/combo-unit';

class FilterLineupsByTeamCombinations implements FilterLineupsByTeamCombinationsInterface {
    constructor(
        private readonly checkedCombinations: ComboUnitInterface[] = [],
        private readonly lineupIds: string[] = [],
    ) {}
    hasCheckedCombinations(): boolean {
        return !isEmpty(this.checkedCombinations);
    }
    isComboChecked(comboUnit: ComboUnitInterface): boolean {
        for (const checkedCombo of this.checkedCombinations) {
            if (checkedCombo.getUnitId() === comboUnit.getUnitId()) {
                return true;
            }
        }

        return false;
    }
    getCheckedCombinations(): ComboUnitInterface[] {
        return this.checkedCombinations;
    }
    getLineupIds(): string[] {
        return this.lineupIds;
    }
    getLineupsQuantity(): number {
        return this.lineupIds.length;
    }
}

const filterLineupsByTeamCombinations = new FilterLineupsByTeamCombinations();

export default function (state = filterLineupsByTeamCombinations, action) {
    switch (action.type) {
        case Const.FILTER_LINEUPS_BY_TEAM_COMBINATIONS_SET_COMBO:
            const {checkedCombinations, lineupIds} = action.data;

            return new FilterLineupsByTeamCombinations(checkedCombinations, lineupIds);

        case Const.FILTER_LINEUPS_BY_PLAYERS_SET_PLAYER:
        case Const.UNSET_LINEUPS:
        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new FilterLineupsByTeamCombinations();

        default:
            return state;
    }
}
